module.exports = __webpack_public_path__ + "img/1.230bba21.png";